import { useSelector } from "react-redux";
import { getBrandedFaresComparisonTable, getBrandedFaresComparisonTableCompact, getFareOffersWithDetails } from "../../store/brandedFareOffers/selectors.js";
import { getSearchResultsFlights } from "../../store/searchResults/selectors.js";
import { getSearchResultsFlights as getOutboundFlights } from "../../store/searchResultsBounds/outboundSelectors.js";
import { getSearchResultsFlights as getInboundFlights } from "../../store/searchResultsBounds/inboundSelectors.js";
export default function useBrandedFares(baseOfferToken) {
    const fareOffersWithDetails = useSelector(getFareOffersWithDetails);
    return fareOffersWithDetails?.[baseOfferToken] || {};
}
const findComparisonTableInFlights = (flights, token) => flights?.find((f) => f.token === token)?.brandedFareComparisonTable;
const findComparisonTableCompactInFlights = (flights, token) => flights?.find((f) => f.token === token)?.brandedFareComparisonTableCompact;
export function useBrandedFaresComparisonTable(baseOfferToken) {
    return useSelector((state) => {
        const comparisonTable = getBrandedFaresComparisonTable(state, baseOfferToken);
        if (comparisonTable)
            return comparisonTable;
        return (findComparisonTableInFlights(getSearchResultsFlights(state), baseOfferToken) ??
            findComparisonTableInFlights(getOutboundFlights(state), baseOfferToken) ??
            findComparisonTableInFlights(getInboundFlights(state), baseOfferToken));
    });
}
export function useBrandedFaresComparisonTableCompact(baseOfferToken) {
    return useSelector((state) => {
        const comparisonTable = getBrandedFaresComparisonTableCompact(state, baseOfferToken);
        if (comparisonTable)
            return comparisonTable;
        return (findComparisonTableCompactInFlights(getSearchResultsFlights(state), baseOfferToken) ??
            findComparisonTableCompactInFlights(getOutboundFlights(state), baseOfferToken) ??
            findComparisonTableCompactInFlights(getInboundFlights(state), baseOfferToken));
    });
}
